export enum TrackingCategory {
    InternalPromotion = 'InternalPromotion',
}
